import { colors } from "@qivia/ui/src/styles/figmaColors";
import { PublicTransactionsPropsType } from "./transactionsAPI";

export const fakeTransactionsDisplayedForDemo: PublicTransactionsPropsType[] = [
  {
    uuid: "6256a7b4-6268-461e-ad6d-fa6524753094",
    amount: 10,
    registrationNumber: "AA-123-AA",
    merchantName: "Intermarché",
    merchantCity: "Grenoble",
    cardLast4Digits: "0005",
    driverName: "Grace Hall",
    driverPhone: "+33686551615",
    status: "REJECTED",
    date: new Date().toISOString(),
    time: new Date().toISOString(),
    reasonsRefused: ["UNAUTHORIZE_MERCHANT"],
    mileage: 0,
    vehicleReference: "",
    supportingDocumentStatus: "MISSING",
    driverLastName: "Hall",
    driver: null,
    ruleName: "Véhicules de direction",
    ruleUuid: "6256a7b4-6268-461e-ad6d-fa6524753091",
    vehicleUuid: "6256a7b4-6268-461e-ad6d-fa6524753092",
    cardUuid: "6256a7b4-6268-461e-ad6d-fa6524753093",
    category: null,
    merchantGroup: "INTERMARCHE",
    categoryAlreadyCorrected: false,
    fuel: null,
    quantity: null,
    type: "EXPENSE",
  },
  {
    uuid: "6256a7b4-6268-461e-ad6d-fa6524753000",
    amount: 20,
    registrationNumber: "BB-123-ZZ",
    merchantName: "Intermarché",
    merchantCity: "Grenoble",
    cardLast4Digits: "0005",
    driverName: "Grace Hall",
    driverPhone: "+33686551615",
    status: "REJECTED",
    date: new Date().toISOString(),
    time: new Date().toISOString(),
    reasonsRefused: ["UNAUTHORIZE_MERCHANT"],
    mileage: 0,
    vehicleReference: "",
    supportingDocumentStatus: "MISSING",
    driverLastName: "Hall",
    driver: null,
    ruleName: "Véhicules de direction",
    ruleUuid: "6256a7b4-6268-461e-ad6d-fa6524753001",
    vehicleUuid: "6256a7b4-6268-461e-ad6d-fa6524753002",
    cardUuid: "6256a7b4-6268-461e-ad6d-fa6524753003",
    category: null,
    merchantGroup: "INTERMARCHE",
    categoryAlreadyCorrected: false,
    fuel: null,
    quantity: null,
    type: "EXPENSE",
  },
];

export const authorizationStatusProps = {
  autorisé: {
    backgroundColor: colors["colors/system/success/success_ultraLight"],
    textColor: colors["colors/system/success/success_normal"],
  },
  "non autorisé": {
    backgroundColor: colors["colors/system/error/error_ultraLight"],
    textColor: colors["colors/system/error/error_normal"],
  },
  "crédit insuffisant": {
    backgroundColor: colors["colors/system/error/error_ultraLight"],
    textColor: colors["colors/system/error/error_normal"],
  },
  expiré: {
    backgroundColor: colors["colors/system/error/error_ultraLight"],
    textColor: colors["colors/system/error/error_normal"],
  },
  bloqué: {
    backgroundColor: colors["colors/system/error/error_ultraLight"],
    textColor: colors["colors/system/error/error_normal"],
  },
};
